import { render, staticRenderFns } from "./LinkedBankAccounts.vue?vue&type=template&id=fa05efd4&scoped=true"
import script from "./LinkedBankAccounts.vue?vue&type=script&lang=ts"
export * from "./LinkedBankAccounts.vue?vue&type=script&lang=ts"
import style0 from "./LinkedBankAccounts.vue?vue&type=style&index=0&id=fa05efd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa05efd4",
  null
  
)

export default component.exports